import React, { useState, useContext, useEffect } from "react"

import { Box, CircularProgress, Grid, Paper, Tooltip } from "@material-ui/core"
import {
  IconButtonDatatable,
  InputAsyncOptionMaster,
  InputCheckboxMaster,
  InputOptionMaster,
  InputReactDatepicker,
  InputTextMaster,
  Loading,
  MasterButton,
  TableToolbar,
} from "App/Component/ui"
import { v4 as uuidv4 } from "uuid"
import { SearchIcon } from "App/Assets"
import {
  STATE_TAMBAH_PAKET,
  checkoutBedTagihan,
  deleteListPaket,
  getKunjunganByTagihanId,
  getListPaket,
  urlGetPatientExternal,
  urlGetPatientInternal,
} from "."
import {
  getAge,
  isNull,
  formatRupiah,
  fetchData,
  defaultToastError,
  defaultToastSuccess,
  oneMonthBeforeToday,
  today,
} from "App/utils/helpers"
import { FormContext } from "../context/FormContext"
import { ModalKunjunganBaru } from "App/Component/layout/Registrasi/KunjunganRawatJalan/ui"
import { STATUS_OPEN_DRAFT_TAGIHAN } from "utils/billing"
import { messageError } from "utils/all"
import { useSelector } from "react-redux"
import {
  DEFAULT_BOX_SHADOW,
  JENIS_RAWAT,
  TYPE_INSTANCE3,
  instance1,
} from "App/constants"
import { Clear, Sync, SyncDisabled } from "@material-ui/icons"
import Add from "App/Assets/icons/Add"
import { makeStyles } from "@material-ui/styles"
import ModalDeleteConfirm from "App/Component/ui/Modal/ModalDeleteConfirm/ModalDeleteConfirm"
import ModalTambahPaket from "./ModalTambahPaket"
import { getAllListHistoryBed } from "App/Component/layout/Manajemen/Bed/ui/TabHistori/helpers"
import { dateFormat } from "utils/dates"

export default function FormInputTagihan({
  classes,
  reloadTagihan,
  rowsKunjungan,
  setRowsKunjungan,
}) {
  const [showModalKunjunganBaru, setShowModalKunjunganBaru] = useState(false)
  const [showModalTambahPaket, setShowModalTambahPaket] = useState(false)
  const [loading, setLoading] = useState(false)
  const [idDelete, setIdDelete] = useState("")
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false)
  const [formPaket, setFormPaket] = useState(STATE_TAMBAH_PAKET)
  const [loadingBed, setLoadingBed] = useState(false)
  const [rowsbeds, setRowsBeds] = useState([])
  const [isCheckoutBed, setIsCheckoutBed] = useState(false)

  const { formData, setFormData, formError, dataPaket, setDataPaket } =
    useContext(FormContext)
  const master = useSelector(({ master }) => master)
  const asuransi = master.asuransi.list_select
  const kelasKunjungan = master.kelas_kunjungan.list_select
  const jenisLayanan = master.all_jenis_layanan.list_select

  const useStyles = makeStyles({
    rootListPaket: {
      padding: "1rem",
      boxShadow: DEFAULT_BOX_SHADOW,
      borderRadius: "8px",
      backgroundColor: "#00b0f2",
      color: "#fff",
      fontSize: "12px",
      fontWeight: "bold",
    },
  })

  const classess = useStyles()

  const handleGetList = async () => {
    setLoading(true)
    const res = await getListPaket(formData.tagihan_id)
    if (res.state) {
      setDataPaket(res.data)
    } else {
      setDataPaket([])
      defaultToastError(res.message)
    }
    setLoading(false)
  }

  const getConfigCheckout = async () => {
    try {
      const api = await instance1.post("/setting/list", {
        id: "",
        kode_setting: "BED_PENJUALAN_OTOMATIS",
        kategori_id: "",
        jumlah: 10,
        halaman: 1,
      })
      if (parseInt(api.status) === 200) {
        const val =
          parseInt(api.data?.data[0]?.setting_data_1 ?? "0") === Number(1)
        if (val) {
          setIsCheckoutBed(true)
        }
      }
    } catch (error) {
      console.log("ERROR GET CONFIG CHECKOUT BED:" + error)
    }
  }

  useEffect(() => {
    ;(async () => {
      await getConfigCheckout()
      if (!isNull(formData.tagihan_id)) {
        await handleGetList()
      } else {
      }
    })()
  }, [formData.tagihan_id]) // eslint-disable-line react-hooks/exhaustive-deps

  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    })
  }

  const changeSelect = (e, name_id, name_label) => {
    setFormData({
      ...formData,
      [name_id]: e?.value,
      [name_label]: e?.label,
    })
  }

  const handleClickSelect = (row) => {
    setFormData({
      ...formData,
      rm_name: row.fullname,
      rm_id: row.id,
      kunjungan_id: "",
      asuransi_id: row.insurance_id,
      asuransi_no: row.insurance_number,
      asuransi: row.insurance_name,
      rm_umur: getAge(row.date_ob),
      rm_tanggal_lahir: dateFormat({
        date: row.date_ob,
        formatDate: "DD MMMM YYYY",
      }),
      no_npwp: row.npwp,
    })
    setShowModalKunjunganBaru(false)
  }

  const preLoadData = async (inputValue) => {
    const res = await fetchData(
      TYPE_INSTANCE3,
      "/tagihan-paket/resource-master-paket",
      "body",
      {
        params: {
          id_kelas: formData.kelas_id,
          id_asuransi: formData.asuransi_id,
          limit: 20,
          search: isNull(inputValue) ? "" : inputValue,
        },
      },
    )

    if (res) {
      const data = []

      res.map((item) => {
        return data.push({
          value: item.id_paket,
          label: `${item.nama_paket} - Rp.${formatRupiah(item.harga_awal)}`,
          id_mh_paket: item.id_mh_paket,
          harga_awal: item.harga_awal,
          nama_paket: item.nama_paket,
        })
      })

      return data
    } else {
      return []
    }
  }

  const processDelete = async () => {
    const res = await deleteListPaket(idDelete)
    if (res.state) {
      reloadTagihan()
      handleGetList()
      defaultToastSuccess(res.message)
    } else {
      defaultToastError(res?.message ?? "Terjadi kesalahan pada server")
    }
    setShowModalDeleteConfirm(!showModalDeleteConfirm)
  }

  const handleClickDelete = (id) => {
    setShowModalDeleteConfirm(!showModalDeleteConfirm)
    setIdDelete(id)
  }

  const addData = () => {
    setFormPaket({
      id_tagihan: formData.tagihan_id,
      id_mh_paket: 0,
      id_paket: 0,
      harga_awal: 0,
      harga: 0,
      nama_paket: "",
      remark: "",
    })
    setShowModalTambahPaket(true)
  }

  const getColumnSizeInput = () => {
    if (formData.is_paket && formData.is_checkout_bed) {
      return 6
    } else if (formData.is_paket || formData.is_checkout_bed) {
      return 4
    } else {
      return 3
    }
  }

  const getColumnSizeForm = () => {
    if (formData.is_paket && formData.is_checkout_bed) {
      return 6
    } else if (formData.is_paket || formData.is_checkout_bed) {
      return 9
    } else {
      return 12
    }
  }

  const handleCheckoutBed = async (e) => {
    try {
      setLoadingBed(true)
      const checked = e.target.checked

      if (checked) {
        const resKunjungan = await getKunjunganByTagihanId(formData.tagihan_id)
        if (resKunjungan.state) {
          setRowsKunjungan(() => resKunjungan.data)
          const onlyRanap = resKunjungan.data?.filter(
            (x) => x.typeofcare_code === JENIS_RAWAT.RAWAT_INAP,
          )

          for (const i in onlyRanap) {
            const payload = {
              id_kunjungan: onlyRanap[i].kunjungan_id,
              id_rm: "",
              id_kelas: "",
              nama_rm: "",
              rm_id: "",
              nama_bed: "",
              kelas: "",
              tgl_mulai: oneMonthBeforeToday(),
              tgl_selesai: today(),
              pages: 1,
              limit: 10,
            }
            const res = await getAllListHistoryBed(
              payload,
              payload.pages,
              payload.limit,
            )
            if (res.state) {
              onlyRanap[i].beds = res.data
            }
          }

          setRowsBeds(onlyRanap)

          setFormData({
            ...formData,
            is_checkout_bed: true,
          })
        }
      } else {
        setFormData({
          ...formData,
          is_checkout_bed: false,
        })
      }
    } catch (error) {
      console.log("ERROR CLICK CHECKOUT BED:" + error)
    } finally {
      setLoadingBed(false)
    }
  }

  return (
    <>
      {showModalTambahPaket && (
        <ModalTambahPaket
          handleGetList={handleGetList}
          setShowModal={setShowModalTambahPaket}
          formPaket={formPaket}
          setFormPaket={setFormPaket}
          reloadTagihan={reloadTagihan}
        />
      )}
      {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          confirmHandle={() => processDelete()}
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
        />
      )}
      {showModalKunjunganBaru && (
        <ModalKunjunganBaru
          formData={formData}
          setFormData={setFormData}
          urlPatientExternal={urlGetPatientExternal}
          urlPatientInternal={urlGetPatientInternal}
          handleClickSelect={handleClickSelect}
          setShowModal={() => setShowModalKunjunganBaru(false)}
        />
      )}
      <form action="">
        <Grid container spacing={1}>
          <Grid item sm={12} md={getColumnSizeForm()}>
            <Paper
              className={classes.paper}
              style={{
                padding: "1rem",
              }}
            >
              <Grid container spacing={1}>
                <Grid item sm={12}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      columnGap: "10px",
                      alignItems: "center",
                    }}
                  >
                    {/* Checkout Bed */}
                    {loadingBed && <CircularProgress size={15} />}

                    {isCheckoutBed && (
                      <InputCheckboxMaster
                        checked={formData.is_checkout_bed}
                        name="is_checkout_bed"
                        id="is_checkout_bed"
                        onClick={(e) => {
                          handleCheckoutBed(e)
                        }}
                        label="CHECKOUT BED"
                        marginTop={"0px"}
                        style={{
                          width: "20px",
                          height: "20px",
                          paddingTop: "0px!important",
                        }}
                      />
                    )}

                    {/* Paket */}

                    <InputCheckboxMaster
                      checked={formData.is_paket}
                      name="is_paket"
                      id="is_paket"
                      onClick={() => {
                        setFormData({
                          ...formData,
                          is_paket: !formData.is_paket,
                        })
                      }}
                      label="PAKET"
                      disabled={
                        formData.status_tagihan === STATUS_OPEN_DRAFT_TAGIHAN
                          ? false
                          : true
                      }
                      marginTop={"0px"}
                      style={{
                        width: "20px",
                        height: "20px",
                        paddingTop: "0px!important",
                      }}
                    />
                  </div>
                </Grid>
                <Grid item sm={6} md={getColumnSizeInput()}>
                  <InputTextMaster
                    name="tagihan_id"
                    label="ID"
                    id="tagihan_id"
                    placeholder="ID"
                    disabled={true}
                    readOnly={true}
                    value={formData.tagihan_id}
                    onChange={handleChange("tagihan_id")}
                  />
                </Grid>
                <Grid item sm={6} md={getColumnSizeInput()}>
                  <InputTextMaster
                    name="rm_id"
                    label="ID RM"
                    id="rm_id"
                    disabled={true}
                    placeholder={formData.rm_id}
                    error={true}
                    message={messageError.required}
                    withButton={true}
                  >
                    {formData.status_tagihan === STATUS_OPEN_DRAFT_TAGIHAN && (
                      <button
                        onClick={() =>
                          setShowModalKunjunganBaru(!showModalKunjunganBaru)
                        }
                        type={"button"}
                        style={{
                          borderRight: "1px solid #EAEAEA",
                          borderTop: "1px solid #EAEAEA",
                          borderBottom: "1px solid #EAEAEA",
                          borderLeft: "0",
                          background: "#fff",
                          padding: "0 0.8rem",
                          cursor: "pointer",
                          borderRadius: "0 6px 6px 0",
                        }}
                      >
                        <SearchIcon width={"12"} height={"12"} fill={"#333"} />
                      </button>
                    )}
                  </InputTextMaster>
                </Grid>

                <Grid item sm={6} md={getColumnSizeInput()}>
                  <InputOptionMaster
                    name="kelas_id"
                    label="KELAS"
                    id="kelas_id"
                    error={formError?.kelas_id}
                    message={formError?.kelas_id}
                    withSearch={true}
                    data={kelasKunjungan}
                    disabled={
                      formData.status_tagihan === STATUS_OPEN_DRAFT_TAGIHAN
                        ? false
                        : true
                    }
                    readOnly={
                      formData.status_tagihan === STATUS_OPEN_DRAFT_TAGIHAN
                        ? false
                        : true
                    }
                    value={formData.kelas_id}
                    labelValue={formData.kelas_name}
                    onChange={(e) => changeSelect(e, "kelas_id", "kelas_name")}
                  />
                </Grid>

                <Grid item sm={6} md={getColumnSizeInput()}>
                  <InputReactDatepicker
                    selected={formData.date}
                    label="TANGGAL"
                    disabled={
                      formData.status_tagihan === STATUS_OPEN_DRAFT_TAGIHAN
                        ? false
                        : true
                    }
                    readOnly={
                      formData.status_tagihan === STATUS_OPEN_DRAFT_TAGIHAN
                        ? false
                        : true
                    }
                    dateFormat="dd/MM/yyyy HH:mm"
                    timeFormat="HH:mm"
                    showTimeSelect
                    timeIntervals={5}
                    handleChangeToday={(e) =>
                      setFormData({
                        ...formData,
                        date: e,
                      })
                    }
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        date: e,
                      })
                    }
                  />
                </Grid>

                <Grid item sm={6} md={getColumnSizeInput()}>
                  <InputTextMaster
                    name="rm_name"
                    label="NAMA RM"
                    disabled={true}
                    readOnly={true}
                    id="rm_name"
                    placeholder="Nama RM"
                    value={formData.rm_name}
                    onChange={handleChange("rm_name")}
                  />
                </Grid>

                <Grid item sm={6} md={getColumnSizeInput()}>
                  <InputReactDatepicker
                    selected={formData.rm_tanggal_lahir}
                    label="TANGGAL LAHIR"
                    disabled={true}
                    readOnly={true}
                    dateFormat="dd MMMM yyyy"
                    withToday={false}
                  />
                </Grid>

                <Grid item sm={6} md={getColumnSizeInput()}>
                  <InputTextMaster
                    name="rm_umur"
                    label="UMUR"
                    disabled={true}
                    readOnly={true}
                    id="rm_umur"
                    placeholder="Umur"
                    value={formData.rm_umur}
                    onChange={handleChange("rm_umur")}
                  />
                </Grid>

                <Grid item sm={6} md={getColumnSizeInput()}>
                  <InputOptionMaster
                    name="jenis_layanan_id"
                    label="JENIS LAYANAN"
                    id="jenis_layanan_id"
                    withSearch={true}
                    disabled={
                      formData.status_tagihan === STATUS_OPEN_DRAFT_TAGIHAN
                        ? false
                        : true
                    }
                    readOnly={
                      formData.status_tagihan === STATUS_OPEN_DRAFT_TAGIHAN
                        ? false
                        : true
                    }
                    data={jenisLayanan}
                    error={formError?.jenis_layanan_id}
                    message={formError?.jenis_layanan_id}
                    value={formData.jenis_layanan_id}
                    labelValue={formData.jenis_layanan_name}
                    onChange={(e) =>
                      changeSelect(e, "jenis_layanan_id", "jenis_layanan_name")
                    }
                  />
                </Grid>
                <Grid item sm={6} md={getColumnSizeInput()}>
                  <InputTextMaster
                    name="no_sep"
                    label="NO SEP"
                    id="no_sep"
                    placeholder="No SEP"
                    disabled={
                      formData.status_tagihan === STATUS_OPEN_DRAFT_TAGIHAN
                        ? false
                        : true
                    }
                    readOnly={
                      formData.status_tagihan === STATUS_OPEN_DRAFT_TAGIHAN
                        ? false
                        : true
                    }
                    error={formError?.no_sep}
                    message={formError?.no_sep}
                    value={formData.no_sep}
                    onChange={handleChange("no_sep")}
                  />
                </Grid>

                <Grid item sm={6} md={getColumnSizeInput()}>
                  <InputOptionMaster
                    name="company_id"
                    label="PERUSAHAAN"
                    id="company_id"
                    withSearch={true}
                    data={master.perusahaan.list_select}
                    value={formData.company_id}
                    labelValue={formData.company_name}
                    // error={true}
                    // message={messageError.required}
                    onChange={(e) => {
                      if (isNull(e)) {
                        setFormData({
                          ...formData,
                          company_id: null,
                          company_name: "Pilih Perusahaan",
                        })
                      } else {
                        setFormData({
                          ...formData,
                          company_id: e.value,
                          company_name: e.label,
                        })
                      }
                    }}
                  />
                </Grid>

                <Grid item sm={6} md={getColumnSizeInput()}>
                  <InputOptionMaster
                    name="asuransi_id"
                    label="ASURANSI"
                    id="asuransi_id"
                    disabled={
                      formData.status_tagihan === STATUS_OPEN_DRAFT_TAGIHAN
                        ? false
                        : true
                    }
                    readOnly={
                      formData.status_tagihan === STATUS_OPEN_DRAFT_TAGIHAN
                        ? false
                        : true
                    }
                    withSearch={true}
                    data={asuransi}
                    value={formData.asuransi_id}
                    labelValue={formData.asuransi}
                    error={true}
                    message={messageError.required}
                    onChange={(e) => changeSelect(e, "asuransi_id", "asuransi")}
                  />
                </Grid>

                <Grid item sm={6} md={getColumnSizeInput()}>
                  <InputTextMaster
                    name="asuransi_no"
                    label="NO ASURANSI"
                    id="asuransi_no"
                    error={formError?.asuransi_no}
                    message={formError?.asuransi_no}
                    disabled={
                      formData.status_tagihan === STATUS_OPEN_DRAFT_TAGIHAN
                        ? false
                        : true
                    }
                    readOnly={
                      formData.status_tagihan === STATUS_OPEN_DRAFT_TAGIHAN
                        ? false
                        : true
                    }
                    placeholder="No Asuransi"
                    value={formData.asuransi_no}
                    onChange={handleChange("asuransi_no")}
                  />
                </Grid>

                <Grid item sm={6} md={getColumnSizeInput()}>
                  <InputTextMaster
                    name="no_npwp"
                    label="NO NPWP"
                    id="no_npwp"
                    disabled={
                      formData.status_tagihan === STATUS_OPEN_DRAFT_TAGIHAN
                        ? false
                        : true
                    }
                    readOnly={
                      formData.status_tagihan === STATUS_OPEN_DRAFT_TAGIHAN
                        ? false
                        : true
                    }
                    placeholder="No NPWP"
                    value={formData.no_npwp}
                    onChange={handleChange("no_npwp")}
                  />
                </Grid>

                <Grid item sm={6} md={getColumnSizeInput()}>
                  <InputTextMaster
                    name="keterangan"
                    label="KETERANGAN"
                    id="keterangan"
                    disabled={
                      formData.status_tagihan === STATUS_OPEN_DRAFT_TAGIHAN
                        ? false
                        : true
                    }
                    readOnly={
                      formData.status_tagihan === STATUS_OPEN_DRAFT_TAGIHAN
                        ? false
                        : true
                    }
                    placeholder="Keterangan"
                    value={formData.keterangan}
                    onChange={handleChange("keterangan")}
                  />
                </Grid>

                <Grid item sm={6} md={getColumnSizeInput()}>
                  <InputTextMaster
                    name="biaya_administrasi"
                    label="BIAYA ADMINISTRASI"
                    id="biaya_administrasi"
                    disabled={
                      formData.status_tagihan === STATUS_OPEN_DRAFT_TAGIHAN
                        ? false
                        : true
                    }
                    readOnly={
                      formData.status_tagihan === STATUS_OPEN_DRAFT_TAGIHAN
                        ? false
                        : true
                    }
                    placeholder="Dalam %"
                    value={formData.biaya_administrasi}
                    onChange={(e) => {
                      let val = e.target.value
                      setFormData({
                        ...formData,
                        biaya_administrasi: isNull(val)
                          ? val
                          : formatRupiah(val),
                      })
                    }}
                  />
                </Grid>

                {/* <Grid item sm={6} md={getColumnSizeInput()}>
            <InputTextMaster
              name='penanggung'
              label='PENANGGUNG'
              id='penanggung'
              disabled={
                formData.status_tagihan === STATUS_OPEN_DRAFT_TAGIHAN
                  ? false
                  : true
              }
              readOnly={
                formData.status_tagihan === STATUS_OPEN_DRAFT_TAGIHAN
                  ? false
                  : true
              }
              placeholder='Penanggung'
              value={formData.penanggung}
              onChange={handleChange("penanggung")}
            />
          </Grid> */}

                <Grid item sm={6} md={getColumnSizeInput()}>
                  <InputTextMaster
                    name="untuk_pembayaran"
                    label="UNTUK PEMBAYARAN"
                    id="untuk_pembayaran"
                    placeholder="Untuk Pembayaran"
                    value={formData.untuk_pembayaran}
                    onChange={handleChange("untuk_pembayaran")}
                  />
                </Grid>
              </Grid>
            </Paper>
          </Grid>
          {formData.is_checkout_bed && (
            <>
              <Grid item sm={12} md={3}>
                <Paper
                  className={classes.paper}
                  style={{
                    padding: "1rem",
                    // height: "100%",
                  }}
                >
                  <TableToolbar
                    title={"Beds"}
                    style={{
                      padding: "0px",
                      minHeight: "3vh",
                    }}
                  ></TableToolbar>
                  <CheckoutBeds rows={rowsbeds} />
                </Paper>
              </Grid>
            </>
          )}
          {formData.is_paket ? (
            <>
              <Grid item sm={12} md={3}>
                <Paper
                  className={classes.paper}
                  style={{
                    padding: "1rem",
                    // height: "100%",
                  }}
                >
                  <TableToolbar
                    title={"List Paket"}
                    style={{ padding: "0px", minHeight: "3vh" }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "7px",
                      }}
                    >
                      <IconButtonDatatable
                        style={{
                          backgroundColor: isNull(formData.tagihan_id)
                            ? ""
                            : "#296218",
                        }}
                        onClick={() =>
                          isNull(formData.tagihan_id) ? null : addData()
                        }
                      >
                        <Tooltip title={"Tambah Pasien"} aria-label="add">
                          <Add fontSize={"small"} style={{ color: "#fff" }} />
                        </Tooltip>
                      </IconButtonDatatable>

                      <IconButtonDatatable
                        style={{
                          backgroundColor: isNull(formData.tagihan_id)
                            ? ""
                            : "#296218",
                        }}
                        onClick={() =>
                          // isNull(formData.tagihan_id)
                          //   ? null
                          //   : refreshData(bed_id)
                          handleGetList(formData.tagihan_id)
                        }
                      >
                        <Tooltip
                          title={"Refresh Data List"}
                          aria-label="refresh"
                        >
                          {isNull(formData.tagihan_id) ? (
                            <SyncDisabled
                              fontSize={"small"}
                              style={{ color: "#fff" }}
                            />
                          ) : (
                            <Sync
                              fontSize={"small"}
                              style={{ color: "#fff" }}
                            />
                          )}
                        </Tooltip>
                      </IconButtonDatatable>
                    </div>
                  </TableToolbar>
                  <Grid container spacing={1}>
                    <Grid item sm={12}>
                      <InputAsyncOptionMaster
                        label="PAKET"
                        name="paket"
                        id={uuidv4()}
                        needParse={false}
                        withSearch={true}
                        data={[]}
                        disabled={
                          isNull(formData.tagihan_id)
                            ? true
                            : formData.status_tagihan !==
                              STATUS_OPEN_DRAFT_TAGIHAN
                            ? true
                            : false
                        }
                        loadOptions={preLoadData}
                        value={"Pilih Paket"}
                        labelValue={"Pilih Paket"}
                        defaultData={"Pilih Paket"}
                        onChange={(e) => {
                          if (isNull(e)) {
                          } else {
                            try {
                              setFormPaket({
                                id_tagihan: formData.tagihan_id,
                                id_mh_paket: e.id_mh_paket,
                                id_paket: e.value,
                                harga_awal: formatRupiah(e.harga_awal),
                                harga: formatRupiah(e.harga_awal),
                                nama_paket: e.nama_paket,
                                remark: "",
                              })
                              setShowModalTambahPaket(true)
                            } catch (error) {
                              console.log(error)
                            }
                          }
                        }}
                        error={true}
                        message={
                          isNull(formData.kelas_id)
                            ? "Harap pilih Kelas Kunjungan terlebih dahulu"
                            : isNull(formData.asuransi_id)
                            ? "Harap pilih Asuransi terlebih dahulu"
                            : ""
                        }
                      />
                    </Grid>
                    <Grid item sm={12}>
                      <Loading show={loading} />
                      <Box
                        style={{
                          height: "263px",
                          overflow: "auto",
                          overflowX: "hidden",
                          // padding: "0px 5px",
                        }}
                      >
                        {dataPaket.length > 0 ? (
                          dataPaket.map((item, index) => {
                            return (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  marginBottom: "1rem",
                                }}
                                className={classess.rootListPaket}
                                key={index}
                              >
                                <div>
                                  {item.nama_paket}
                                  <br />
                                  <span>Rp. {formatRupiah(item.harga)}</span>
                                </div>
                                <div>
                                  {formData.status_tagihan ===
                                  STATUS_OPEN_DRAFT_TAGIHAN ? (
                                    <IconButtonDatatable
                                      style={{
                                        backgroundColor: "#CC2B1D",
                                      }}
                                      onClick={() =>
                                        handleClickDelete(item.id_tagihan_paket)
                                      }
                                    >
                                      <Tooltip
                                        title={"Hapus Paket"}
                                        aria-label="delete"
                                      >
                                        <Clear
                                          fontSize={"small"}
                                          style={{ color: "#fff" }}
                                        />
                                      </Tooltip>
                                    </IconButtonDatatable>
                                  ) : (
                                    <></>
                                  )}
                                </div>
                              </div>
                            )
                          })
                        ) : (
                          <div
                            style={{
                              width: "100%",
                              height: "100%",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <span>Tidak Ada Data</span>
                          </div>
                        )}
                      </Box>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
            </>
          ) : (
            <></>
          )}
        </Grid>
      </form>
    </>
  )
}

const CheckoutBeds = ({ rows }) => {
  const [openConfirm, setOpenConfirm] = useState(false)
  const [ID, setID] = useState()

  const handleCheckout = async () => {
    const res = await checkoutBedTagihan(ID)
    if (res.state) {
      defaultToastSuccess(res.message ?? "Berhasil checkout bed")
      setOpenConfirm(false)
    } else {
      defaultToastError(res.message ?? "Gagal checkout bed")
    }
  }

  const onClickCheckout = (id_kunjungan) => {
    setID(id_kunjungan)
    setOpenConfirm(true)
  }

  // console.log(rows, "rowss")

  return (
    <div
      style={{
        display: "flex",
        overflow: "auto",
        columnGap: "10px",
        height: "100%",
      }}
    >
      {openConfirm && (
        <ModalDeleteConfirm
          confirmHandle={() => handleCheckout()}
          setShowModalDeleteConfirm={() => setOpenConfirm(false)}
        />
      )}
      {rows?.map((item, index) => {
        return (
          <div
            key={index}
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <div
              style={{
                columnGap: "10px",
              }}
            >
              <Tooltip title="ID Kunjungan">
                <p
                  style={{
                    fontSize: "14px",
                    padding: "5px 10px",
                    backgroundColor: "#D8D8D8",
                  }}
                >
                  #{item?.kunjungan_id}
                </p>
              </Tooltip>
              <ul>
                {item.beds.length === 0 ? (
                  <p style={{ fontSize: "11px", textAlign: "center" }}>
                    Tidak ada bed
                  </p>
                ) : (
                  item?.beds?.map((item2, index2) => {
                    return (
                      <li
                        key={index2}
                        style={{
                          fontSize: "12px",
                          listStyleType: "none",
                          padding: "3px 10px",
                        }}
                      >
                        {item2.bed_name}
                      </li>
                    )
                  })
                )}
              </ul>
            </div>
            <div style={{ padding: "0 2px" }}>
              <MasterButton
                name={"Checkout"}
                color={item.beds?.length === 0 ? "secondary" : "danger"}
                onClick={() => {
                  onClickCheckout(item.kunjungan_id)
                }}
                disabled={item.beds?.length === 0}
                type={"button"}
                size={"sm"}
              />
            </div>
          </div>
        )
      })}
    </div>
  )
}

// const BedPerkunjungan = () => {
//   return (

//   )
// }
